import { SetStateAction, useEffect, useState } from 'react'
import img_1 from '../../shared/style/images/career/career_tekla_hero.webp'
import { PortItem } from '../portfolio/PortItem';
import { IMotion } from '../../shared/interfaces/IMotion';
import { motion as m } from "framer-motion";

interface Props {
  motion: IMotion
};

export const Career = ({ motion }: Props) => {






  return (
    <div className="about-page">
      <div className='about-box' style={{alignItems:"start"}}>
        {/* <img src={img_1} style={{height:"20rem", width:"auto"}} alt="" /> */}
        <h3><strong style={{textDecoration:"underline"}}> Checker - Steel Detailer</strong> position.</h3>
        <br />
        <h4>Job Description:</h4>
        <ul style={{padding:"0 5rem"}}>
          <li>Have a minimum 5 years of experience working as a Checker in a Steel Detailing office.</li>
          <li>Be self motivated and able to follow tasks thru to completion with minimal guidance.</li>
          <li>Be able to check Tekla model against contract drawing information.</li>
          <li>Check that shop drawings meet client standards, information is presented to make fabrication as efficient as possible and that shop drawings conform to the design documents.</li>
          <li>Coordinate with Project Manager and detailing team to ensure schedules are met and quality of the final product.</li>
          <li>Supervise and train junior staff.</li>
          <li>Estimate costs.</li>
          <li>Have good English language skills both written and oral.</li>
          <li>Have good working knowledge of office computer applications. Gmail & Google Docs.</li>
          <li>Be a team player able to function under pressure and meet deadlines.</li>
          <li>Experience working with Tekla Structures and AutoCAD. Revit experience would be an asset.</li>
          <li>Experience working on commercial projects such as schools, office buildings, airports, etc. is preferable</li>
          <li>Applications only being accepted for Canadian citizens or Permanent Residents.</li>
        </ul>
        <br />
        <p>Eligible for Group Benefits Plan after 3 months. Plan includes life insurance, long term disability, healthcare, and dental care.</p>
        <br />
        <p><strong>Job Type:</strong>  Full-time, permanent. 40 hour work week in office.  This is not a remote work position.</p>
        <br />
        <p><strong>Language:</strong>  English.</p>
        <br />
        <p><strong>Start Date of Employment (approx.):</strong>  As soon as possible.</p>
        <br />
        <p><strong>Salary:</strong> $37.50/hour.</p>
        <br />
        <p><strong>How to Apply:</strong>  Send Cover Letter and Resume to <strong>general@qualitydraftingco.com</strong></p>

      </div>

      <br />
      <div className='about-box' style={{alignItems:"start"}}>
        {/* <img src={img_1} style={{height:"20rem", width:"auto"}} alt="" /> */}
        <h3> <strong style={{textDecoration:"underline"}}> Senior Steel Detailer / Project Manager</strong> position.</h3>
        <br />
        <p>We are looking to add an experienced Senior Steel Detailer / Project Manager to our team. This role requires a highly organized professional with experience in both commercial and industrial steel projects, excellent communication skills, and ability to manage multiple projects.</p>
        <br />
        <h4>Key Responsibilities:</h4>
        <ul style={{padding:"0 5rem"}}>
          <li>Lead and manage structural steel detailing projects from kickoff to final delivery</li>
          <li>Produce and oversee accurate steel detailing models and shop drawings</li>
          <li>Review and approve - Shop drawings, Erection drawings, Advanced Bill of Materials, CNC and fabrication outputs</li>
          <li>BIM meetings and collaboration</li>
          <li>Coordinate project RFIs, schedules,  priorities, and deliverables with internal teams</li>
          <li>Track and manage the dynamic flow of changing project priorities and design information</li>
          <li>Ensure all drawings comply with project specifications and fabrication requirements</li>
          <li>Communicate directly with fabrication and design teams to resolve issues efficiently</li>
          <li>Work effectively to maintain project schedules and overcome problems due to design changes and incomplete design drawings.</li>
          <li>Mentor junior detailers and strive for continuous improvement</li>
        </ul>
        <br />

        <h4>Required Qualifications:</h4>
        <ul style={{padding:"0 5rem"}}>
          <li>Applications only being accepted for Canadians or Permanent Residents.</li>
          <li>Minimum 5 to 10 years of structural steel detailing experience</li>
          <li>Strong project management and coordination background in structural steel detailing</li>
          <li>Expert-level proficiency in: Tekla Structures</li>
          <li>Extensive experience with: Structural steel shop drawings, connection detailing, fabrication and erection processes</li>
          <li>Strong understanding of structural and architectural drawings</li>
          <li>Ability to manage multiple projects and deadlines while working as part of a team</li>
          <li>Excellent organizational, communication, and problem-solving skills</li>
          <li>Experience with Revit would be an asset</li>
        </ul>
        <br />

        <p>Eligible for Group Benefits Plan after 3 months. Plan includes life insurance, long term disability, healthcare, and dental care.</p>
        <br />
        <p><strong>Job Type:</strong>  Full-time, permanent. 40 hour work week in office.  This is not a remote work position.</p>
        <br />
        <p><strong>Language:</strong>  English.</p>
        <br />
        <p><strong>Start Date of Employment (approx.):</strong>  As soon as possible.</p>
        <br />
        <p><strong>How to Apply:</strong>  Send Cover Letter and Resume to <strong>general@qualitydraftingco.com</strong></p>

      </div>

    </div>
  )
}
